import { render, staticRenderFns } from "./customer_sales_amounts.vue?vue&type=template&id=73c0b1ae&scoped=true"
import script from "./customer_sales_amounts.vue?vue&type=script&lang=js"
export * from "./customer_sales_amounts.vue?vue&type=script&lang=js"
import style0 from "./customer_sales_amounts.vue?vue&type=style&index=0&id=73c0b1ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c0b1ae",
  null
  
)

export default component.exports